var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1058.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section-options",
    transform: "translate(822.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(57.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-spacing",
    transform: "translate(179.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#FFFFFF",
    strokeWidth: 1.16666667
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,13.4166667 L5.83333333,13.4166667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99166667,13.4166667 L11.2,13.4166667",
    strokeDasharray: "2.138908267021179,2.138908267021179"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.25 13.4166667 13.4166667 13.4166667 13.4166667 12.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4166667,10.15 L13.4166667,2.8",
    strokeDasharray: "2.099999944368999,2.099999944368999"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13.4166667 1.75 13.4166667 0.583333333 12.25 0.583333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.15,0.583333333 L2.8,0.583333333",
    strokeDasharray: "2.099999944368999,2.099999944368999"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1.75 0.583333333 0.583333333 0.583333333 0.583333333 1.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.583333333,3.90833333 L0.583333333,7.11666667",
    strokeDasharray: "2.138908267021179,2.138908267021179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.583333333,8.16666667 L0.583333333,9.33333333"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1495CD",
    fillRule: "nonzero",
    x: 0,
    y: 8.16666667,
    width: 5.83333333,
    height: 5.83333333
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.16666667,
    points: "5.83333333 4.08333333 9.91666667 4.08333333 9.91666667 8.16666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,8.75 L9.68333333,4.31666667",
    id: "Path",
    stroke: "#1495CD",
    strokeWidth: 1.16666667
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpacing);
export default __webpack_public_path__ + "static/media/icon-spacing.fc2d287624a48811f964ea9c9082d1e4.svg";
export { ForwardRef as ReactComponent };